import {forwardRef} from 'react'

import PropTypes from 'prop-types'

import {PanelBasic} from '@adv-mt/mt-panel-basic'

import PanelPriceIndicatorFaqs from './components/Faqs/index.js'
import PanelPriceIndicatorRanks from './components/Ranks/index.js'
import PanelPriceIndicatorTitle from './components/Title/index.js'
import PanelPriceIndicatorTooltip from './components/Tooltip/index.js'
import {usePriceIndicator} from './hooks/usePriceIndicator.js'
import {BASE_CLASS} from './config.js'

const PanelPriceIndicator = forwardRef(({average, offerTypeId, price, rank}, forwardedRef) => {
  const {description, ranks, faqs} = usePriceIndicator({average, offerTypeId, rank})

  return (
    <div className={BASE_CLASS} ref={forwardedRef}>
      <PanelBasic>
        <PanelPriceIndicatorTitle description={description} />
        <PanelPriceIndicatorTooltip average={average} offerTypeId={offerTypeId} price={price} rank={rank} />
        <PanelPriceIndicatorRanks ranks={ranks} />
        <PanelPriceIndicatorFaqs faqs={faqs} />
      </PanelBasic>
    </div>
  )
})

PanelPriceIndicator.displayName = 'PanelPriceIndicator'

PanelPriceIndicator.propTypes = {
  average: PropTypes.number,
  offerTypeId: PropTypes.number,
  price: PropTypes.number,
  rank: PropTypes.number
}

export default PanelPriceIndicator
